import { render, staticRenderFns } from "./InformDialog.vue?vue&type=template&id=ee5752dc&scoped=true&"
import script from "./InformDialog.vue?vue&type=script&lang=js&"
export * from "./InformDialog.vue?vue&type=script&lang=js&"
import style0 from "./InformDialog.vue?vue&type=style&index=0&id=ee5752dc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee5752dc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRow})
